import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuerySample } from '@store/helpers';

export const liabilityApi = createApi({
  reducerPath: 'Liability',
  tagTypes: ['Liability'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    getLiabilityTableData: builder.mutation({
      query: ({
        page,
        size,
        body = {},
        params = { sortBy: 'expirationDate', sortDir: 'desc' },
      }) => ({
        url: `/v1/contractors/insurance/contractor?page=${page}&size=${size}`,
        method: 'POST',
        body,
        params,
      }),
    }),
    getLiabilityById: builder.query({
      query: ({ id }) => ({
        url: `/v1/contractors/insurance/${id}`,
      }),
    }),
    createOrUpdateLiability: builder.mutation({
      query: ({ id, body, method }) => ({
        url: `/v1/contractors/insurance/${id ? `update/${id}` : 'create'}`,
        method,
        body,
      }),
    }),
  }),
});

export const {
  useGetLiabilityTableDataMutation,
  useLazyGetLiabilityByIdQuery,
  useCreateOrUpdateLiabilityMutation,
} = liabilityApi;
